import React, { useEffect, useState } from 'react';
import './EasterEggs.css';

const EasterEggs = () => {
  const [konamiActivated, setKonamiActivated] = useState(false);
  const [secretMode, setSecretMode] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);

  // Konami Code: ↑ ↑ ↓ ↓ ← → ← → B A
  useEffect(() => {
    const konamiCode = [
      'ArrowUp', 'ArrowUp',
      'ArrowDown', 'ArrowDown',
      'ArrowLeft', 'ArrowRight',
      'ArrowLeft', 'ArrowRight',
      'KeyB', 'KeyA'
    ];
    let konamiIndex = 0;

    const handleKeyDown = (e) => {
      if (e.code === konamiCode[konamiIndex]) {
        konamiIndex++;
        if (konamiIndex === konamiCode.length) {
          activateKonami();
          konamiIndex = 0;
        }
      } else {
        konamiIndex = 0;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Developer Console Messages
  useEffect(() => {
    const messages = [
      '%c🚀 Welcome to Sadiq Haruna\'s Portfolio!',
      'color: #ff6b35; font-size: 24px; font-weight: bold;',
      '%c👨‍💻 Looking for Easter eggs? Try the Konami Code!',
      'color: #ffa726; font-size: 16px;',
      '%c⬆️ ⬆️ ⬇️ ⬇️ ⬅️ ➡️ ⬅️ ➡️ B A',
      'color: #ff8c61; font-size: 14px;',
      '%c💡 Tip: Triple-click my name in the header!',
      'color: #ffb74d; font-size: 14px;',
      '%c🎨 Built with React, Three.js, and lots of ☕',
      'color: #ff6b35; font-size: 14px;',
      '%c📧 Want to hire me? Let\'s talk!',
      'color: #ffa726; font-size: 16px; font-weight: bold;'
    ];

    messages.forEach((msg, i) => {
      if (i % 2 === 0) {
        console.log(msg, messages[i + 1]);
      }
    });

    // Hidden ASCII art
    console.log(`
    ╔═══════════════════════════════════════╗
    ║                                       ║
    ║     SADIQ HARUNA - FULL STACK DEV     ║
    ║                                       ║
    ║   React • Node.js • AWS • Healthcare  ║
    ║                                       ║
    ║   🚀 Building the future, one line    ║
    ║      of code at a time                ║
    ║                                       ║
    ╚═══════════════════════════════════════╝
    `);

    // Secret developer mode hint
    console.log('%c🔐 Secret: Type "dev" anywhere on the page', 'color: #ff6b35; font-size: 12px;');
  }, []);

  // Secret "dev" mode
  useEffect(() => {
    let typedKeys = '';
    const handleKeyPress = (e) => {
      typedKeys += e.key;
      if (typedKeys.includes('dev')) {
        activateSecretMode();
        typedKeys = '';
      }
      if (typedKeys.length > 10) {
        typedKeys = typedKeys.slice(-10);
      }
    };

    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, []);

  const activateKonami = () => {
    setKonamiActivated(true);
    setShowConfetti(true);
    
    // Play sound effect (optional)
    console.log('🎮 KONAMI CODE ACTIVATED! 🎮');
    console.log('%c🌟 You found the secret! You\'re awesome! 🌟', 'color: gold; font-size: 20px; font-weight: bold;');
    
    // Show notification
    alert('🎮 KONAMI CODE ACTIVATED! 🎮\n\nYou found the secret!\nEnjoy the confetti! 🎉');

    setTimeout(() => {
      setShowConfetti(false);
    }, 5000);
  };

  const activateSecretMode = () => {
    setSecretMode(true);
    console.log('%c🔓 DEVELOPER MODE ACTIVATED! 🔓', 'color: #00ff00; font-size: 18px; font-weight: bold;');
    console.log('%cYou now have X-ray vision! 👀', 'color: #00ff00; font-size: 14px;');
    
    alert('🔓 DEVELOPER MODE ACTIVATED!\n\nYou can now see the matrix! 👀');

    setTimeout(() => {
      setSecretMode(false);
    }, 10000);
  };

  // Triple-click Easter egg
  const handleTripleClick = () => {
    setClickCount(prev => prev + 1);
    
    if (clickCount + 1 === 3) {
      console.log('%c🎯 TRIPLE CLICK DETECTED! 🎯', 'color: #ff6b35; font-size: 18px;');
      alert('🎯 You found a secret!\n\nYou\'re persistent! I like that! 😄');
      setClickCount(0);
    }

    setTimeout(() => setClickCount(0), 1000);
  };

  return (
    <>
      {/* Konami Code Confetti */}
      {showConfetti && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                backgroundColor: ['#ff6b35', '#ffa726', '#ff8c61', '#ffb74d'][Math.floor(Math.random() * 4)]
              }}
            />
          ))}
        </div>
      )}

      {/* Konami Activated Badge */}
      {konamiActivated && (
        <div className="konami-badge">
          <span className="konami-icon">🎮</span>
          <span>KONAMI ACTIVATED!</span>
        </div>
      )}

      {/* Secret Developer Mode */}
      {secretMode && (
        <div className="secret-mode-overlay">
          <div className="matrix-rain">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="matrix-column"
                style={{
                  left: `${i * 5}%`,
                  animationDelay: `${Math.random() * 2}s`
                }}
              >
                {[...Array(20)].map((_, j) => (
                  <span key={j} className="matrix-char">
                    {String.fromCharCode(33 + Math.floor(Math.random() * 94))}
                  </span>
                ))}
              </div>
            ))}
          </div>
          <div className="secret-mode-message">
            <h2>🔓 DEVELOPER MODE</h2>
            <p>You can see the matrix now! 👀</p>
          </div>
        </div>
      )}

      {/* Hidden Click Target */}
      <div 
        className="easter-egg-trigger" 
        onClick={handleTripleClick}
        title="Triple-click me!"
      />
    </>
  );
};

export default EasterEggs;
